import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { flourishConfig } from '../../constants';
export var getFlourishStyles = props => {
  var _a, _b;
  return StyleSheet.create({
    container: {
      position: 'relative'
    },
    icon: {
      position: 'absolute',
      left: ((_a = props === null || props === void 0 ? void 0 : props.offset) === null || _a === void 0 ? void 0 : _a.x) || 0,
      top: ((_b = props === null || props === void 0 ? void 0 : props.offset) === null || _b === void 0 ? void 0 : _b.y) || 0,
      height: '100%',
      width: '100%'
    }
  });
};
export var getFlourishProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(flourishConfig === null || flourishConfig === void 0 ? void 0 : flourishConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.flourish) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};